module.exports = __webpack_public_path__ + "static/media/permablok-plus.a5832921.svg";